export const PRODUCT_FRUITS_WORKSPACE_CODE = '7uVe5jM8CXC25g3m'

export const UNREGISTERED_USER = 'unregistered'

export const QA_NAME_GRETA_AI_LAUNCHER = 'gretaAIChatLauncher'

export const LAUNCHER_ROW_ATTRIBUTE = 'data-launcher-row'

export const LAUNCHER_ROW_WIDTH_PROPERTY = '--layout-overlay-launcher-row-width'
